import { createSlice } from '@reduxjs/toolkit'
import { OutputRecipientList } from 'common/api/v1/types'
import type { ApplicationException } from '../../api/ApplicationException'
import {
  clearGroupList,
  createGroupList,
  getGroupList,
  getGroupLists,
  removeGroupList,
  removeGroupLists,
  updateGroupList,
} from '../actions/groupListsActions'

import { logoutUser } from '../actions/userActions'
import { isOneOf } from '../actions'
import { createLoadingReducer } from './shared'

interface State {
  formErrors?: ApplicationException['errorInfo']['details']
  loading: boolean
  groupList?: OutputRecipientList
  groupLists: Array<OutputRecipientList>
  saving?: boolean
  total: number
}
export const initialStateGroupLists: State = {
  groupLists: [],
  loading: false,
  total: 0,
}

const { isLoadingAction, loadingReducer } = createLoadingReducer<State>(removeGroupList, getGroupLists)

const groupListsSlice = createSlice({
  name: 'groupLists',
  initialState: initialStateGroupLists,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        getGroupLists.fulfilled,
        (state, { payload: { items: groupLists, total } }): State => ({
          ...state,
          groupLists,
          total,
        }),
      )
      .addCase(getGroupList.fulfilled, (state, { payload: groupList }): State => ({ ...state, groupList }))
      .addCase(clearGroupList, (state): State => ({ ...state, groupList: undefined, formErrors: undefined }))
      .addCase(logoutUser.fulfilled, (): State => initialStateGroupLists)
      .addCase(
        removeGroupList.fulfilled,
        (state, { payload: { id } }): State => ({
          ...state,
          groupLists: state.groupLists.filter((groupList) => groupList.id !== id),
          total: state.total - 1,
        }),
      )
      .addCase(
        removeGroupLists.fulfilled,
        (state, { payload: ids }): State => ({
          ...state,
          groupLists: state.groupLists.filter((groupList) => !ids.includes(groupList.id)),
          total: state.total - ids.length,
        }),
      )
      .addMatcher(
        isOneOf([updateGroupList.pending, createGroupList.pending]),
        (state): State => ({ ...state, saving: true }),
      )
      .addMatcher(
        isOneOf([createGroupList.fulfilled, updateGroupList.fulfilled]),
        (state): State => ({
          ...state,
          saving: undefined,
          formErrors: undefined,
        }),
      )
      .addMatcher(
        isOneOf([updateGroupList.rejected, createGroupList.rejected]),
        (state, { payload }): State => ({
          ...state,
          saving: false,
          formErrors: payload?.details,
        }),
      )
      .addMatcher(isLoadingAction, loadingReducer)
  },
})

export default groupListsSlice.reducer
